<template>
  <div :class="$style['pt-notice-detail']">
      <pt-page-title title="消息详情" ></pt-page-title>
       <pt-sub-title title="消息详情"></pt-sub-title>
       <table :class="$style['pt-notice-detail-table']">
             <pt-message-table-item label="消息标题">
                 {{noticeDetail.title}}
            </pt-message-table-item>
            <pt-message-table-item label="发送对象">
                <div :class="$style['send-to-obj']">
                 {{noticeDetail.send_to}}
                 <el-button  v-if="noticeDetail.sendTo" type="text" @click="viewUser">查看</el-button>
                 </div>
            </pt-message-table-item>
            <pt-message-table-item label="发送时间">
                 {{noticeDetail.created_date}}
            </pt-message-table-item>
            <pt-message-table-item label="消息内容">
                <div :class="$style['notice-content']">
                    {{noticeDetail.content}}
                </div>
            </pt-message-table-item>
       </table>
        <el-dialog :visible.sync="is_dialog" :title="dialog_title" @close="closeDialog" class="user-dialog">
            <select-view-user v-if="is_view_user"  :pageSize="6" :userIds="noticeDetail.sendTo" parameter="userLoginList" filed="userLogin" @close="closeDialog"></select-view-user>
        </el-dialog>
  </div>
</template>

<script>
// 组件class前缀
import selectViewUser from 'cps/customer-manage/select-view-user'

const prefixCls = 'pt-notice-detail'
export default {
  name: 'pt-notice-detail',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    is_dialog: {
      get: function () {
        return this.is_view_user
      },
      set: function (val) {
        this.is_view_user = val
      }
    }
  },
  props: {
    noticeDetail: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  components: {
    selectViewUser
  },
  data () {
    return {
      is_view_user: false,
      dialog_title: ''
    }
  },
  methods: {
    viewUser () {
      this.is_view_user = true
      this.dialog_title = '查看用户'
    },
    closeDialog () {
      this.is_view_user = false
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-notice-detail{
}
.pt-notice-detail-table{
    padding:0 20px;
    width: 100%;
    display: block;
    box-sizing: border-box;
        :global
    tr{
        width: 100%;
        display: inline-flex;
        td{
            display: flex;
        line-height: 40px;
            &:last-child{
                flex: 1;
                justify-content: flex-start;
            }
        }
    }
}
.notice-content{
    padding: 10px 20px;
    width: 100%;
    background-color: #F9F9F9;
    white-space: inherit!important;
    justify-content: flex-start!important;
}
.send-to-obj{
    display: flex;
    line-height: 40px;
    :global
    .el-button{
        color: #edbe81;
        margin-left: 10px;

        *{
            color: #edbe81;
        }
    }
}
</style>
<style lang="less">
 .user-dialog{
        .el-dialog{
        width: 70%;
        min-width: 1100PX;
        max-width: 1200Px;
    }
    .el-dialog__body{
     padding: 0 20px 30px;
    }
    }
</style>
